import { capitalize } from 'lodash';
import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { NumberField, SelectField } from 'react-admin';
import Label from '../../../customFields/Label';
import TransactionTypeConfigurationField from '../../../customFields/TransactionTypeConfigurationField';
import { timePeriodChoices } from '../../../constants/timePeriods';
import anomalyDeviationDirections, { anomalyDeviationDirectionChoices } from '../../../constants/anomalyDeviationDirections';
import { transactionMonitoringModesChoices } from '../../../constants/transactionMonitoringMode';

const SimpleAnomalyDetectionWithoutWindow = () => (
  <Grid size={12}>
    <Grid container spacing={1}>
      <Grid size={12}>
        <Label
          variant="label"
          title="Transaction types configuration"
        />
      </Grid>
      <Grid size={12}>
        <TransactionTypeConfigurationField source="ruleParameters.transactionTypeConfiguration" />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="Transaction monitoring mode"
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectField
          choices={transactionMonitoringModesChoices}
          source="ruleParameters.transactionMonitoringMode"
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="The deviation percentage and direction which this rule should detect."
          info={(
            <Box>
              <Typography>
                <Box component="span" fontWeight="bold">
                  Lower.
                </Box>
                {' '}
                Detect if the deviation is lower than the historical average.
              </Typography>
              <Typography>
                <Box component="span" fontWeight="bold">
                  Higher.
                </Box>
                {' '}
                Detect if the deviation is higher than the historical average.
              </Typography>
              <Typography>
                <Box component="span" fontWeight="bold">
                  Both.
                </Box>
                {' '}
                Detect both lower and higher deviation from the historical average.
              </Typography>
            </Box>
          )}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Typography>
          <NumberField source="ruleParameters.threshold" label="Deviation (%)" />
          %
        </Typography>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectField
          choices={anomalyDeviationDirectionChoices}
          source="ruleParameters.deviationDirection"
          emptyText={capitalize(anomalyDeviationDirections.BOTH)}
          label="Deviation Direction"
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="The minimum number of transactions that must have been made by the entity for rule to apply"
        />
      </Grid>
      <Grid size={12}>
        <NumberField source="ruleParameters.minimumNumberOfObservations" />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="Minimum usage time"
          info="The period will determine if a entity have been in the system long enough to be used."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberField
          source="ruleParameters.minimumUsageTime.amount"
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectField
          choices={timePeriodChoices}
          source="ruleParameters.minimumUsageTime.unit"
        />
      </Grid>

      <Grid size={12}>
        <Label
          variant="label"
          title="Period to consider"
          info="The period that will be used to determine the start of the history to include."
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <NumberField
          source="ruleParameters.periodToConsider.amount"
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <SelectField
          choices={timePeriodChoices}
          source="ruleParameters.periodToConsider.unit"
        />
      </Grid>
    </Grid>
  </Grid>
);

export default SimpleAnomalyDetectionWithoutWindow;
